import React from 'react'
import './footer.css'
import logo from '../../asset/logoWithName.svg'
import { useLocation } from 'react-router-dom'

export default function Footer() {
    const location = useLocation();
  return (
    <div className='footer'>
        <div id='footerContainer' className="footerContainer">
            <div className="logoName">
                <img src={logo} alt="" />
            </div>
            <div className="mail">
                <h3>write us</h3>
                <p>nasim.stg@gmail.com</p>
            </div>
            <div className="social">
                <h3>follow us</h3>
                <div className="socialIcons">
                    <a href=""><img src="" alt="fb" /></a>
                    <a href=""><img src="" alt="yt" /></a>
                    <a href=""><img src="" alt="dc" /></a>
                    <a href=""><img src="" alt="gh" /></a>
                </div>
            </div>
            <div className="address">
                <h3>cup of coffee</h3>
                <p>Tejgaon, Dhaka</p>
            </div>
        </div>
        {
            location.pathname !=='/contact' &&
        <div className="copyright">
            <p>© 2022 wOOeNe All rights reserved.</p>
        </div>
        }
    </div>
  )
}
